// src/keys/sha256.ts
var K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
function rotr(x, n) {
  return x >>> n | x << 32 - n;
}
function utf8Encode(s) {
  return new TextEncoder().encode(s);
}
function sha256Bytes(msg) {
  const l = msg.length;
  const bitLen = BigInt(l) * 8n;
  const withPad = new Uint8Array(l + 9 + 63 >> 6 << 6);
  withPad.set(msg);
  withPad[l] = 128;
  const bitLenView = new DataView(withPad.buffer);
  bitLenView.setUint32(withPad.length - 4, Number(bitLen & 0xffffffffn), false);
  bitLenView.setUint32(withPad.length - 8, Number(bitLen >> 32n), false);
  let h0 = 1779033703;
  let h1 = 3144134277;
  let h2 = 1013904242;
  let h3 = 2773480762;
  let h4 = 1359893119;
  let h5 = 2600822924;
  let h6 = 528734635;
  let h7 = 1541459225;
  const w = new Uint32Array(64);
  const view = new DataView(withPad.buffer);
  for (let i = 0; i < withPad.length; i += 64) {
    for (let t = 0; t < 16; t++) w[t] = view.getUint32(i + t * 4, false);
    for (let t = 16; t < 64; t++) {
      const s0 = rotr(w[t - 15], 7) ^ rotr(w[t - 15], 18) ^ w[t - 15] >>> 3;
      const s1 = rotr(w[t - 2], 17) ^ rotr(w[t - 2], 19) ^ w[t - 2] >>> 10;
      w[t] = w[t - 16] + s0 + w[t - 7] + s1 >>> 0;
    }
    let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
    for (let t = 0; t < 64; t++) {
      const S1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25);
      const ch = e & f ^ ~e & g;
      const temp1 = h + S1 + ch + K[t] + w[t] >>> 0;
      const S0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22);
      const maj = a & b ^ a & c ^ b & c;
      const temp2 = S0 + maj >>> 0;
      h = g;
      g = f;
      f = e;
      e = d + temp1 >>> 0;
      d = c;
      c = b;
      b = a;
      a = temp1 + temp2 >>> 0;
    }
    h0 = h0 + a >>> 0;
    h1 = h1 + b >>> 0;
    h2 = h2 + c >>> 0;
    h3 = h3 + d >>> 0;
    h4 = h4 + e >>> 0;
    h5 = h5 + f >>> 0;
    h6 = h6 + g >>> 0;
    h7 = h7 + h >>> 0;
  }
  const out = new Uint8Array(32);
  const outView = new DataView(out.buffer);
  [h0, h1, h2, h3, h4, h5, h6, h7].forEach((x, i) => outView.setUint32(i * 4, x >>> 0, false));
  return out;
}
function bytesToHex(bytes) {
  let hex = "";
  for (let i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, "0");
  return hex;
}

// src/ids/index.ts
function webCrypto() {
  return globalThis.crypto;
}
function randomBytes(count) {
  const bytes = new Uint8Array(count);
  const crypto = webCrypto();
  if (typeof crypto?.getRandomValues === "function") crypto.getRandomValues(bytes);
  else for (let i = 0; i < count; i++) bytes[i] = Math.floor(Math.random() * 256);
  return bytes;
}
function hexOf(bytes) {
  let hex = "";
  for (const byte of bytes) hex += byte.toString(16).padStart(2, "0");
  return hex;
}
function randomUuid() {
  const crypto = webCrypto();
  if (typeof crypto?.randomUUID === "function") return crypto.randomUUID();
  const bytes = randomBytes(16);
  bytes[6] = bytes[6] & 15 | 64;
  bytes[8] = bytes[8] & 63 | 128;
  const hex = hexOf(bytes);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

// src/singleton/index.ts
var BRAND_NAMESPACE = "@authe/fe-commons/brand/";
var ordinaryHasInstance = Function.prototype[Symbol.hasInstance];
function brandClass(cls, key) {
  const brand = /* @__PURE__ */ Symbol.for(BRAND_NAMESPACE + key);
  Object.defineProperty(cls.prototype, brand, { value: true });
  Object.defineProperty(cls, Symbol.hasInstance, {
    value(value) {
      if (this !== cls) return ordinaryHasInstance.call(this, value);
      return typeof value === "object" && value !== null && value[brand] === true;
    }
  });
}

// src/signing/index.ts
var ALG = {
  name: "ECDSA",
  namedCurve: "P-256",
  hash: { name: "SHA-256" }
};
function subtle() {
  const c = globalThis.crypto;
  if (!c?.subtle) throw new Error("Web Crypto (crypto.subtle) is unavailable in this runtime.");
  return c.subtle;
}
function canonicalJson(value) {
  if (value === null || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`;
  const obj = value;
  const entries = Object.keys(obj).sort().map((k) => `${JSON.stringify(k)}:${canonicalJson(obj[k])}`);
  return `{${entries.join(",")}}`;
}
function toBytes(input) {
  if (input instanceof Uint8Array) return input;
  const text = typeof input === "string" ? input : canonicalJson(input);
  return new TextEncoder().encode(text);
}
function b64url(bytes) {
  const arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let bin = "";
  for (const b of arr) bin += String.fromCharCode(b);
  const b64 = typeof btoa !== "undefined" ? btoa(bin) : Buffer.from(arr).toString("base64");
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function generateSigningKeyPair(extractable = false) {
  return subtle().generateKey(ALG, extractable, ["sign", "verify"]);
}
async function exportPublicJwk(key) {
  return subtle().exportKey("jwk", key);
}
async function importPublicJwk(jwk) {
  return subtle().importKey("jwk", jwk, ALG, true, ["verify"]);
}
async function sign(privateKey, payload) {
  const sig = await subtle().sign(ALG, privateKey, toBytes(payload));
  return b64url(sig);
}
async function verify(publicKey, payload, signatureB64Url) {
  const sig = Uint8Array.from(
    atobUrl(signatureB64Url),
    (c) => c.charCodeAt(0)
  );
  return subtle().verify(ALG, publicKey, sig, toBytes(payload));
}
function atobUrl(s) {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
  return typeof atob !== "undefined" ? atob(b64) : Buffer.from(b64, "base64").toString("binary");
}
var TwoKeySigner = class _TwoKeySigner {
  constructor(root, intermediate, rootKeyId, certificate = null) {
    this.root = root;
    this.intermediate = intermediate;
    this.rootKeyId = rootKeyId;
    this.certificate = certificate;
  }
  root;
  intermediate;
  rootKeyId;
  certificate;
  static {
    brandClass(this, "signing/TwoKeySigner");
  }
  static async create(opts = { rootKeyId: "root" }) {
    const root = await generateSigningKeyPair(false);
    const intermediate = await generateSigningKeyPair(false);
    const signer = new _TwoKeySigner(root, intermediate, opts.rootKeyId ?? "root");
    await signer.rotateIntermediate(opts.intermediateTtlMs ?? 15 * 6e4);
    return signer;
  }
  /**
   * Build a signer from an ALREADY-PERSISTED root keypair — e.g. a
   * non-extractable device root `CryptoKeyPair` loaded from IndexedDB — minting a
   * fresh short-lived intermediate. This is the enrolment-aware path: the root
   * key is generated + persisted (and enrolled server-side) ONCE, then reused
   * across sessions so the enrolled `rootKeyId` keeps resolving server-side while
   * the private key never leaves the device.
   */
  static async fromRootKeyPair(opts) {
    const intermediate = await generateSigningKeyPair(false);
    const signer = new _TwoKeySigner(opts.rootKeyPair, intermediate, opts.rootKeyId);
    await signer.rotateIntermediate(opts.intermediateTtlMs ?? 15 * 6e4);
    return signer;
  }
  /** Re-certify the intermediate key with a fresh expiry (root signs it). */
  async rotateIntermediate(ttlMs = 15 * 6e4) {
    const intermediatePublicJwk = await exportPublicJwk(this.intermediate.publicKey);
    const expiresAt = Date.now() + ttlMs;
    const body = { intermediatePublicJwk, rootKeyId: this.rootKeyId, expiresAt };
    const signature = await sign(this.root.privateKey, body);
    this.certificate = { ...body, signature };
    return this.certificate;
  }
  getCertificate() {
    if (!this.certificate) throw new Error("Intermediate key not yet certified \u2014 call rotateIntermediate().");
    return this.certificate;
  }
  /** Sign a request payload with the intermediate key. */
  async signRequest(payload) {
    if (!this.certificate || Date.now() > this.certificate.expiresAt) await this.rotateIntermediate();
    return { signature: await sign(this.intermediate.privateKey, payload), certificate: this.getCertificate() };
  }
  /** Export the root public key (registered with the backend on enrolment). */
  exportRootPublicJwk() {
    return exportPublicJwk(this.root.publicKey);
  }
};
async function verifyTwoKeyRequest(rootPublicKey, certificate, payload, requestSignature) {
  if (Date.now() > certificate.expiresAt) return false;
  const certBody = {
    intermediatePublicJwk: certificate.intermediatePublicJwk,
    rootKeyId: certificate.rootKeyId,
    expiresAt: certificate.expiresAt
  };
  if (!await verify(rootPublicKey, certBody, certificate.signature)) return false;
  const intermediate = await importPublicJwk(certificate.intermediatePublicJwk);
  return verify(intermediate, payload, requestSignature);
}
var HMAC_BLOCK = 64;
function concatBytes(a, b) {
  const out = new Uint8Array(a.length + b.length);
  out.set(a, 0);
  out.set(b, a.length);
  return out;
}
function hmacSha256Hex(key, message) {
  let keyBytes = typeof key === "string" ? utf8Encode(key) : key;
  const msgBytes = typeof message === "string" ? utf8Encode(message) : message;
  if (keyBytes.length > HMAC_BLOCK) keyBytes = sha256Bytes(keyBytes);
  const block = new Uint8Array(HMAC_BLOCK);
  block.set(keyBytes);
  const ipad = new Uint8Array(HMAC_BLOCK);
  const opad = new Uint8Array(HMAC_BLOCK);
  for (let i = 0; i < HMAC_BLOCK; i++) {
    ipad[i] = block[i] ^ 54;
    opad[i] = block[i] ^ 92;
  }
  const inner = sha256Bytes(concatBytes(ipad, msgBytes));
  return bytesToHex(sha256Bytes(concatBytes(opad, inner)));
}
function assembleKey(key) {
  const parts = [...key.base];
  if (key.splice) {
    parts.splice(key.splice.at, 0, ...key.splice.from.slice(key.splice.start, key.splice.end));
  }
  if (key.prepend) {
    return key.prepend.from.slice(key.prepend.start, key.prepend.end).concat(parts).join("");
  }
  return parts.join("");
}
var KEYRING_DECOYS = [
  // index 0 — used when (timestamp % 2 === 0)
  {
    base: ["Z", "n", "V", "j", "a", "y", "U", "g", "Y", "n", "J", "v", "d", "G", "h", "l", "c", "g", "=", "="],
    splice: { at: 6, from: ["9", "L", "9", "P", "c", "n", "f", "5", "V", "d", "B", "5", "b", "3", "j", "c", "9", "U", "w", "6"], start: 10, end: 14 }
  },
  // index 1 — used when (timestamp % 2 === 1)
  {
    base: ["d", "G", "h", "l", "c", "i", "B", "m", "d", "W", "N", "r", "I", "H", "l", "v", "d", "Q", "=", "="],
    prepend: { from: ["X", "O", "r", "i", "i", "6", "H", "H", "Y", "n", "J", "v", "p", "4", "f", "E", "O", "x", "v", "U"], start: 8, end: 12 }
  }
];
var BUILD_INJECTED_KEYRING = typeof __AUTHE_REQUEST_KEY_KEYRING__ !== "undefined" && Array.isArray(__AUTHE_REQUEST_KEY_KEYRING__) ? __AUTHE_REQUEST_KEY_KEYRING__ : KEYRING_DECOYS;
var REQUEST_KEY_VERSION = typeof __AUTHE_REQUEST_KEY_VERSION__ !== "undefined" && __AUTHE_REQUEST_KEY_VERSION__ ? __AUTHE_REQUEST_KEY_VERSION__ : "v1";
var REQUEST_KEY_HEADER = "REQUEST-KEY";
var REQUEST_TS_HEADER = "REQUEST-TS";
var REQUEST_NONCE_HEADER = "REQUEST-NONCE";
var REQUEST_POW_HEADER = "REQUEST-POW";
function canonicalQuery(params) {
  if (!params) return "";
  const keys = Object.keys(params).sort();
  return keys.map((k) => `${k}=${String(params[k])}`).join("&");
}
function defaultMessage(input) {
  const q = canonicalQuery(input.params);
  const base = `${input.url}${q ? (input.url.includes("?") ? "&" : "?") + q : ""}${input.timestamp}`;
  return input.nonce ? `${base}${input.nonce}` : base;
}
function generateRequestKey(input, opts = {}) {
  const keyring = opts.keyring ?? BUILD_INJECTED_KEYRING;
  if (keyring.length === 0) throw new Error("generateRequestKey: empty keyring");
  const selected = keyring[Math.abs(input.timestamp) % keyring.length];
  const key = assembleKey(selected);
  const message = (opts.messageBuilder ?? defaultMessage)(input);
  const r = hmacSha256Hex(key, message);
  const digit = parseInt(r[0], 16) % 10;
  const combined = r.slice(0, 12) + String(digit) + r.slice(-12);
  const chars = combined.split("");
  for (let i = 0; i < chars.length; i++) {
    if (parseInt(r[i % 64], 16) % 10 > 6) chars[i] = chars[i].toUpperCase();
  }
  return chars.join("");
}
function requestKeyHeaders(input, opts) {
  const version = input.version ?? REQUEST_KEY_VERSION;
  const timestamp = input.timestamp ?? Date.now();
  const nonce = input.nonce ?? randomUuid();
  const message = publicSignedMessage(version, timestamp, nonce);
  return {
    [REQUEST_KEY_HEADER]: generateRequestKey(
      { url: "", timestamp, nonce },
      { keyring: opts?.keyring, messageBuilder: opts?.messageBuilder ?? (() => message) }
    ),
    [REQUEST_TS_HEADER]: String(timestamp),
    [REQUEST_NONCE_HEADER]: nonce,
    "X-Request-Key-Version": version
  };
}
function graphqlRequestKeyHeaders(opts = {}) {
  const version = opts.version ?? REQUEST_KEY_VERSION;
  const timestamp = opts.timestamp ?? Date.now();
  const nonce = opts.nonce ?? randomUuid();
  const message = publicSignedMessage(version, timestamp, nonce);
  return {
    [REQUEST_KEY_HEADER]: generateRequestKey(
      { url: "", timestamp, nonce },
      { keyring: opts.keyring, messageBuilder: () => message }
    ),
    [REQUEST_TS_HEADER]: String(timestamp),
    [REQUEST_NONCE_HEADER]: nonce,
    "X-Request-Key-Version": version
  };
}
function publicSignedMessage(version, timestamp, nonce) {
  return `${version}:${timestamp}:${nonce}`;
}
function leadingZeroBits(digest) {
  let bits = 0;
  for (const byte of digest) {
    if (byte === 0) {
      bits += 8;
      continue;
    }
    bits += 8 - (32 - Math.clz32(byte));
    break;
  }
  return bits;
}
var POW_MAX_ITERATIONS = 1 << 26;
function solvePow(challenge, bits, maxIterations = POW_MAX_ITERATIONS) {
  if (bits <= 0) return "0";
  for (let i = 0; i < maxIterations; i++) {
    const digest = sha256Bytes(utf8Encode(`${challenge}:${i}`));
    if (leadingZeroBits(digest) >= bits) return String(i);
  }
  throw new Error(`proof-of-work solution not found within ${maxIterations} iterations`);
}
function publicApiAuthToken(opts = {}) {
  const version = opts.version ?? REQUEST_KEY_VERSION;
  const timestamp = opts.timestamp ?? Date.now();
  const nonce = opts.nonce ?? randomUuid();
  const message = publicSignedMessage(version, timestamp, nonce);
  const requestKey = generateRequestKey(
    { url: "", timestamp },
    { keyring: opts.keyring, messageBuilder: () => message }
  );
  const token = { v: version, t: timestamp, k: requestKey, n: nonce };
  if (opts.powBits && opts.powBits > 0) token.pow = solvePow(message, opts.powBits);
  return b64url(utf8Encode(JSON.stringify(token)));
}
function publicApiRequestKeyHeaders(opts = {}) {
  const version = opts.version ?? REQUEST_KEY_VERSION;
  const timestamp = opts.timestamp ?? Date.now();
  const nonce = opts.nonce ?? randomUuid();
  const message = publicSignedMessage(version, timestamp, nonce);
  const headers = {
    [REQUEST_KEY_HEADER]: generateRequestKey(
      { url: "", timestamp, nonce },
      { keyring: opts.keyring, messageBuilder: () => message }
    ),
    [REQUEST_TS_HEADER]: String(timestamp),
    [REQUEST_NONCE_HEADER]: nonce,
    "X-Request-Key-Version": version
  };
  if (opts.powBits && opts.powBits > 0) headers[REQUEST_POW_HEADER] = solvePow(message, opts.powBits);
  return headers;
}
function publicTwoKeyPayload(nonce, timestamp) {
  return { nonce, timestamp };
}
async function publicApiTwoKeyToken(signer, opts = {}) {
  const timestamp = opts.timestamp ?? Date.now();
  const nonce = opts.nonce ?? randomUuid();
  const { signature, certificate } = await signer.signRequest(publicTwoKeyPayload(nonce, timestamp));
  return b64url(
    utf8Encode(JSON.stringify({ scheme: "two_key", t: timestamp, n: nonce, sig: signature, cert: certificate }))
  );
}
var AUTH_SIGNATURE_HEADER = "X-Auth-Signature";
var AUTH_CERTIFICATE_HEADER = "X-Auth-Certificate";
var AUTH_NONCE_HEADER = "X-Auth-Nonce";
var AUTH_TIMESTAMP_HEADER = "X-Auth-Timestamp";
async function twoKeyRequestHeaders(signer, opts = {}) {
  const timestamp = opts.timestamp ?? Date.now();
  const nonce = opts.nonce ?? randomUuid();
  const { signature, certificate } = await signer.signRequest(publicTwoKeyPayload(nonce, timestamp));
  return {
    [AUTH_SIGNATURE_HEADER]: signature,
    [AUTH_CERTIFICATE_HEADER]: b64url(utf8Encode(JSON.stringify(certificate))),
    [AUTH_NONCE_HEADER]: String(nonce),
    [AUTH_TIMESTAMP_HEADER]: String(timestamp)
  };
}

export { AUTH_CERTIFICATE_HEADER, AUTH_NONCE_HEADER, AUTH_SIGNATURE_HEADER, AUTH_TIMESTAMP_HEADER, REQUEST_KEY_HEADER, REQUEST_KEY_VERSION, REQUEST_NONCE_HEADER, REQUEST_POW_HEADER, REQUEST_TS_HEADER, TwoKeySigner, exportPublicJwk, generateRequestKey, generateSigningKeyPair, graphqlRequestKeyHeaders, hmacSha256Hex, importPublicJwk, publicApiAuthToken, publicApiRequestKeyHeaders, publicApiTwoKeyToken, publicSignedMessage, publicTwoKeyPayload, requestKeyHeaders, sign, solvePow, twoKeyRequestHeaders, verify, verifyTwoKeyRequest };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map